import React, { PropTypes } from 'react';
import Scrollsprite from 'components/Helpers/Scrollsprite/Scrollsprite';
const Hus = () => {
  const style = require('./Hus.scss');
  const sprite = require("./img/hus-sprite-roteramera.jpg");
  return (
    <div className={style.wrapper}>
      <Scrollsprite className={style.hus} sprite={sprite} frames={17} ratio={418/400*100}/>
    </div>
  );
};

export default Hus;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Special/Hus/Hus.js
 **/